<template>
  <div class="table-responsive" v-if="(visible && fetchResult.array.length)">
    <table class="table-responsive table table-sm bg-light fs-6 fw-light">
      <tbody>
        <tr v-for="item, itemKey in fetchResult.array" :key="item" class="border-bottom border-dark">  
          <div class="d-flex flex-row">
            <div class="px-2" v-if="getAPRSSymbolImageClass(item.symboltable+item.symbolcode,24)"><span class="fw-semibold"><i :class="getAPRSSymbolImageClass(item.symboltable+item.symbolcode,24)"></i></span></div>
            <div class="px-2"><span class="fw-semibold">#{{ fetchResult.array.length-itemKey }}</span></div>
            <div class="px-2"><span class="fw-semibold">{{ formatedRTTime(item.receivedTime) }}</span></div>
            <div class="px-2 text-nowrap"><span class="fw-semibold">{{ item.origpacket }}</span></div>
          </div>
          <div class="d-flex align-content-start flex-wrap bg-primary bg-opacity-10">                        
            <div class="px-2" v-if="item.type">{{t('Type:')}}&nbsp;<span class="fw-semibold">{{ item.type }}</span></div>
            <div class="px-2" v-if="item.format">{{t('Format:')}}&nbsp;<span class="fw-semibold">{{ item.format }}</span></div>
            <div class="px-2" v-if="item.symboltable">{{t('Symbol Table:')}}&nbsp;<span class="fw-semibold">{{ item.symboltable }}</span></div>
            <div class="px-2" v-if="item.symbolcode">{{t('Symbol Code:')}}&nbsp;<span class="fw-semibold">{{ item.symbolcode }}</span></div>
            <div class="px-2" v-if="item.destCallsign">{{t('Dest. Callsign:')}}&nbsp;<span class="fw-semibold">{{ item.destCallsign }}</span></div>            
            <div class="px-2" v-if="item.comment">{{t('Comment:')}}&nbsp;<span class="fw-semibold">{{ item.comment }}</span></div>
            <div class="px-2" v-if="item.messageId">{{t('Message Id:')}}&nbsp;<span class="fw-semibold">{{ item.messageId }}</span></div>
            <div class="px-2" v-if="item.message">{{t('Message:')}}&nbsp;<span class="fw-semibold">{{ item.message }}</span></div>
          </div>
          <div class="d-flex align-content-start flex-wrap bg-primary bg-opacity-25" v-if="item.latitude || item.longitude || item.speed || item.course || item.altitude">                        
            <div class="px-2" v-if="item.latitude">{{t('Latitude:')}}&nbsp;<span class="fw-semibold">{{ item.latitude.toFixed(5) }}</span></div>
            <div class="px-2" v-if="item.longitude">{{t('Longitude:')}}&nbsp;<span class="fw-semibold">{{ item.longitude.toFixed(5) }}</span></div>
            <div class="px-2" v-if="item.speed">{{t('Speed:')}}&nbsp;<span class="fw-semibold">{{ item.speed.toFixed(0) }}</span> km/h</div>
            <div class="px-2" v-if="item.course">{{t('Course:')}}&nbsp;<span class="fw-semibold">{{ item.course.toFixed(0) }}</span> °</div>
            <div class="px-2" v-if="item.altitude">{{t('Altitude:')}}&nbsp;<span class="fw-semibold">{{ item.altitude.toFixed(0) }}</span> m</div>
            <div class="px-2" v-if="item.distance">{{t('Dist. From Last Pos.:')}}&nbsp;<span class="fw-semibold">{{ item.distance.toFixed(1) }}</span> m</div>
          </div>
          <div class="d-flex align-content-start flex-wrap text-center bg-primary bg-opacity-50" v-if="item.wx">                        
            <div class="px-2" v-if="item.wx.temp">{{t('Temp:')}}&nbsp;<span class="fw-semibold">{{ item.wx.temp }} °C</span></div>
            <div class="px-2" v-if="item.wx.pressure">{{t('Pressure:')}}&nbsp;<span class="fw-semibold">{{ item.wx.pressure }} hPa</span></div>
            <div class="px-2" v-if="item.wx.humidity">{{t('Humidity:')}}&nbsp;<span class="fw-semibold">{{ item.wx.humidity }} %</span></div>
            <div class="px-2" v-if="item.wx.rain_1h">{{t('Rain 1h:')}}&nbsp;<span class="fw-semibold">{{ item.wx.rain_1h }} mm</span></div>
            <div class="px-2" v-if="item.wx.rain_24h">{{t('Rain 24h:')}}&nbsp;<span class="fw-semibold">{{ item.wx.rain_24h }} mm</span></div>
            <div class="px-2" v-if="item.wx.rain_midnight">{{t('Rain Midnight:')}}&nbsp;<span class="fw-semibold">{{ item.wx.rain_midnight }} mm</span></div>
            <div class="px-2" v-if="item.wx.wind_direction">{{t('Wind Direction:')}}&nbsp;<span class="fw-semibold">{{ item.wx.wind_direction }} °</span></div>
            <div class="px-2" v-if="item.wx.wind_gust">{{t('Wind Gust:')}}&nbsp;<span class="fw-semibold">{{ item.wx.wind_gust }} km/h</span></div>
            <div class="px-2" v-if="item.wx.wind_speed">{{t('Wind Speed:')}}&nbsp;<span class="fw-semibold">{{ item.wx.wind_speed }} km/h</span></div>
          </div>
        </tr>
        <tr v-if="fetchResult.totalDistance && !fetching">
          <div class="d-flex align-content-start flex-wrap text-center bg-primary text-white">
            <div class="px-2">Total Distance: <span class="fw-semibold">~ {{ (fetchResult.totalDistance/1000).toFixed(1) }} km</span></div>
          </div>
        </tr>
      </tbody>
    </table>
  </div>

    <div v-if="(visible && !fetchResult.array.length && !fetching)"
      class="row alert alert-danger align-items-center text-center" role="alert">
      <div class="col-md-10 p-2">{{t('No records found')}}</div>
    </div>

    <div v-if="(fetching)" class="row alert alert-primary" role="alert">
      <div class="d-flex justify-content-center align-items-center">
        <strong>{{t('Loading...')}}</strong>
        <div class="spinner-border mx-2" role="status" aria-hidden="true"></div>
      </div>
    </div>

</template>


<script setup>
import { ref, defineExpose } from 'vue'
import { formatedRTTime } from '../js/tmlf.js'
import { getAPRSSymbolImageClass } from '../js/aprssymbols.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const fetchResult = ref()
const visible = ref(false)

defineExpose({
  visible,
  fetchResult,
});

const fetching = ref(false)

</script>

<i18n>
  {
    "pl": {
      "No records found": "Brak wyników wyszukiwania",
      "Loading...": "Łaowanie...",
      "Type:": "Typ:",
      "Format:": "Format:",
      "Symbol Table:": "Tabela Symbolu:",
      "Symbol Code:": "Kod Symbolu:",
      "Dest. Callsign:": "Adres Przezn.:",
      "Comment:": "Komentarz:",
      "Message Id:": "Nr Wiad.:",
      "Message:": "Wiadomość:",
      "Latitude:": "Szerokość:",
      "Longitude:": "Długość:",
      "Speed:": "Prędkość:",
      "Course:": "Kurs:",
      "Altitude:": "Wysokość:",
      "Dist. From Last Pos.:": "Dystans od Poprz. Poz.",
      "Temp:": "Temp:",
      "Pressure:": "Ciśnienie:",
      "Humidity:": "Wilgotność:",
      "Rain 1h:": "Deszcz 1 godz.:",
      "Rain 24h:": "Deszcz 24 godz.:",
      "Rain Midnight:": "Deszcz od Północy:",
      "Wind Direction:": "Wiatr Kierunek:",
      "Wind Gust:": "Wiatr Porywy:",
      "Wind Speed:": "Wiatr Prędkość:",
    }
  }
</i18n>
